<template>
  <div class="ClientCheck">
    <div class="title">{{ $props.title }}</div>
    <div class="icon">
      <div v-if="$props.value" class="check active" @click="onChange(false)"></div>
      <div v-else class="check " @click="onChange(true)"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "value", "onChange"],
  name: "ClientCheck",
  methods: {
    onClick(value) {
      // console.log(value)
    }
  },
  setup(props) {
    // console.log(props.title)
  },
}
</script>

<style scoped lang="less">
.ClientCheck {
  width: 100%;
  height: 36px;
  background: #b9c8df;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  border-radius: 36px;
  display: flex;
  align-items: center;
  padding: 0 22px;
  box-sizing: border-box;

  .title {
    flex: 1;
  }

  .icon {
    width: 28px;
    height: 28px;
    position: relative;
    cursor: pointer;

    .check {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 45px;
      height: 37.5px;
      background: url("../../../assets/client/check.png") no-repeat center center / 100% 100%;
      cursor: pointer;

      &.active {
        background: url("../../../assets/client/check_active.png") no-repeat center center / 100% 100%;
      }
    }
  }
}
</style>
